import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Gift01 = function Gift01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 6v16m0-16H8.4643c-.521 0-1.0206-.2107-1.389-.5858S6.5 4.5304 6.5 4s.207-1.0391.5753-1.4142S7.9433 2 8.4643 2C11.2143 2 12 6 12 6m0 0h3.5357c.521 0 1.0206-.2107 1.389-.5858.3683-.375.5753-.8838.5753-1.4142s-.207-1.0391-.5753-1.4142S16.0567 2 15.5357 2C12.7857 2 12 6 12 6m8 5v7.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C18.4802 22 17.9201 22 16.8 22H7.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C4 20.4802 4 19.9201 4 18.8V11M2 7.6v1.8c0 .56 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 11 3.04 11 3.6 11h16.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.2401 22 9.96 22 9.4V7.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.2401 6 20.9601 6 20.4 6H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 6.76 2 7.04 2 7.6"
    })
  }));
};
export default Gift01;